var map = {
	"./cover-choose-avatar.png": "21d3",
	"./cover_finish.png": "2341",
	"./gray.png": "361d",
	"./green.png": "feab",
	"./image.png": "bbb3",
	"./pink.png": "cde8",
	"./step00_gray.png": "f8a3",
	"./step00_green.png": "1214",
	"./step00_pink.png": "b6aa",
	"./step10_gray.png": "286f",
	"./step10_green.png": "927a",
	"./step10_pink.png": "ed5b",
	"./step11_gray.png": "3b33",
	"./step11_green.png": "bacf",
	"./step11_pink.png": "e6661",
	"./step2_gray.png": "6deb",
	"./step2_green.png": "6de3",
	"./step2_pink.png": "9ea4",
	"./step3_gray.png": "54f7",
	"./step3_green.png": "ff97",
	"./step3_pink.png": "bda8",
	"./step5_gray.png": "caca",
	"./step5_green.png": "78d3",
	"./step5_pink.png": "7354",
	"./step6_gray.png": "ef3f",
	"./step6_green.png": "8e8d",
	"./step6_pink.png": "9853",
	"./step7_gray.png": "a61b",
	"./step7_green.png": "ed26",
	"./step7_pink.png": "c51b",
	"./step9_gray.png": "a19d",
	"./step9_green.png": "d234",
	"./step9_pink.png": "466c",
	"./welcome_trade_gray.png": "88b8",
	"./welcome_trade_grayc.png": "cb38",
	"./welcome_trade_green.png": "2fec",
	"./welcome_trade_greenc.png": "0231",
	"./welcome_trade_pink.png": "42ca",
	"./welcome_trade_pinkc.png": "ae17"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "507e";